import { Stack, StackProps, styled } from '@mui/material';
import React, { DetailedHTMLProps, useState } from 'react';
import ImageNotSupported from '@mui/icons-material/ImageNotSupportedTwoTone';

const ImageNotFoundWrapper = styled(Stack)<StackProps>(({ theme }) => ({
  borderWidth: 1,
  borderColor: theme.palette.grey[300],
  borderStyle: 'solid',
  backgroundColor: theme.palette.background.default,
  fontSize: theme.typography.fontSize * 4
}));

type HtmlImageType = DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>;

export const ImageWithFallback: React.FC<HtmlImageType> = (props: HtmlImageType) => {
  const { width, height, alt, ...rest } = props;
  const [imageNotFound, setImageNotFound] = useState(false);


  const onImageLoadError = () => {
    setImageNotFound(true);
  };


  return (
    <Stack width={width} height={height}>
      {imageNotFound ?
        (
          <ImageNotFoundWrapper height={height} width={width} alignItems='center' justifyContent='center'>
            <ImageNotSupported color='primary' fontSize='inherit' />
          </ImageNotFoundWrapper>
        ) :
        <img
          alt={alt}
          {...rest}
          onError={onImageLoadError} />
      }
    </Stack>
  );
};